var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Graphics = PIXI.Graphics;
import { selectExpansionInfo } from "../../../selectors/selectExpansionInfo";
import { utilDrawGrid } from "../../../utils/graphics/utilDrawGrid";
import { utilGrid } from "../../../utils/grid/utilGrid";
import { SceneLayer } from "../../scenes/SceneLayer";
import { TypeBuildingAction } from "../buildings/reducerBuildings";
var LayerPlayerBaseGrid = /** @class */ (function (_super) {
    __extends(LayerPlayerBaseGrid, _super);
    function LayerPlayerBaseGrid() {
        var _this = _super.call(this) || this;
        _this.GridLineColor = 0xeeeeee;
        _this.GridFillColor = 0x000000;
        _this.GridFillAlpha = 0.1;
        _this.lastVisibleState = false;
        _this.shouldUpdate = function (state, previousState) {
            return !!state.expansionInfo.unlockedExpansionIds &&
                _this.lastVisibleState !== _this.isVisible(state);
        };
        _this.update = function (props) {
            var _a = props.expansionInfo, unlockedExpansionIds = _a.unlockedExpansionIds, baseSetup = _a.baseSetup;
            if (unlockedExpansionIds != undefined && _this.grids !== undefined) {
                var cache = _this.grids.cacheAsBitmap;
                _this.grids.cacheAsBitmap = false;
                _this.grids.clear();
                unlockedExpansionIds.forEach(function (expansionId) {
                    return _this.drawExpansionGrid(expansionId, baseSetup);
                });
                _this.lastVisibleState = _this.isVisible(props);
                _this.grids.visible = _this.lastVisibleState;
                _this.grids.cacheAsBitmap = cache;
            }
        };
        _this.mapState = function (state) { return ({
            buildings: state.playerBase.buildings,
            expansionInfo: selectExpansionInfo(state),
        }); };
        _this.isVisible = function (props) {
            var _a = props.buildings, building = _a.building, action = _a.action;
            return (!!building &&
                (action === TypeBuildingAction.Construct ||
                    action === TypeBuildingAction.Move ||
                    action === TypeBuildingAction.Unstore));
        };
        _this.drawExpansionGrid = function (expansionId, baseSetup) {
            var _a = utilGrid.expansionIdToXY(expansionId, baseSetup), x = _a.x, y = _a.y;
            utilDrawGrid.draw(_this.grids, {
                fillAlpha: _this.GridFillAlpha,
                fillColor: _this.GridFillColor,
                lineColor: _this.GridLineColor,
                lineWidth: 1,
                originMarkColor: _this.GridLineColor,
                sizeX: baseSetup.expansionsSizeX,
                sizeY: baseSetup.expansionsSizeY,
                x: x,
                y: y,
            });
        };
        _this.grids = new Graphics();
        _this.addChild(_this.grids);
        return _this;
    }
    return LayerPlayerBaseGrid;
}(SceneLayer));
export { LayerPlayerBaseGrid };



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/layers/LayerPlayerBaseGrid.ts
// module id = 2218
// module chunks = 3